export enum AuthEnvironment {
    PPE,    // Pre-Production Environment
    Prod    // Production
}

export enum IdentityType {
    ODP = "MicrosoftAccount", /*Personal Accounts*/
    ODB = "OrganizationAccount"/* Enterprise Accounts */,
    Unsupported = "Unsupported" /*Unsupported Accounts*/
}

export interface IdentityInfo {
    type: IdentityType
}

export type UIAuthProvider=(getAccessToken: ()=>Promise<any>)=>Promise<any>;

export interface IAuthenticationProvider {
    Authenticate(): void;
    GetAccessToken(resource: string): Promise<string>;
    GetAuthEnvironment(): AuthEnvironment;
    SetUIAuthProvider(uiAuthProvider: UIAuthProvider): void;
    GetIdentityInfo(): Promise<IdentityInfo>;
}